// Static policy content - no backend API needed
export const POLICIES = {
  turnaround: {
    title: "Turnaround Policy",
    content: `Turnaround time starts after:
1. Payment is confirmed AND
2. All required intake information is submitted AND
3. Your resume file has been uploaded

If any of these are missing, turnaround is paused until we receive them.

Typical delivery times depend on the service selected after intake and the complexity of the project. Exact turnaround is confirmed as part of the agreed scope before invoicing.`
  },
  revisions: {
    title: "Revision Policy",
    content: `Every project includes reasonable revisions within the agreed scope.

Revision requests must be submitted within 7 days of receiving your first draft.

What's included in a revision:
- Adjustments to wording, formatting, and emphasis
- Adding or modifying bullet points
- Updating target role focus

What's NOT included:
- Complete rewrites for different industries (requires a new project)
- Adding new job experiences not originally discussed
- Changes that significantly expand the original confirmed scope`
  },
  refunds: {
    title: "Refund Policy",
    content: `We offer refunds ONLY if:
1. Your first draft was not delivered within the promised turnaround time AND
2. You choose not to continue with the order

Once a draft has been delivered, the order is considered fulfilled and no refunds are available.

We're confident in our work and want you to be satisfied. If you have concerns, please reach out before requesting a refund.`
  },
  disclaimers: {
    title: "Service Disclaimers",
    content: `Important disclaimers:

NO JOB GUARANTEES: We do not guarantee interviews, job offers, or any specific employment outcomes. Resume writing is a tool to present your qualifications effectively.

NO FABRICATION: We do not invent experience, skills, or accomplishments. All content is based on information you provide.

ACCURACY: You are responsible for confirming all metrics, dates, and claims in your resume are accurate.

ATS OPTIMIZATION: While we optimize for Applicant Tracking Systems, no resume can guarantee passage through every ATS.`
  },
  privacy: {
    title: "Privacy Policy",
    content: `Your privacy matters to us.

DATA USE: Your resume, intake information, and files are used solely to deliver your ordered services.

NO SELLING: We never sell your personal information or resume content to third parties.

RETENTION: Files are retained for 90 days after order completion to allow for support requests, then automatically deleted.

SECURITY: All files are stored securely and transmitted over encrypted connections.`
  },
  apply_assist: {
    title: "Application Support Terms",
    content: `Application Support Terms:

SERVICE SCOPE: We source job opportunities matching your profile and provide structured support with applications after you approve each one.

APPROVAL REQUIRED: You must approve each job before we apply. We never apply without your explicit consent.

NO AUTOMATION: All applications are submitted manually by our team - no bots or automated tools.

NO ACCOUNT ACCESS: We never request or store your job board passwords or account credentials.

DURATION: The scope and application count are confirmed as part of your agreed project before invoicing.

OUTCOMES: We provide progress tracking, but do not guarantee interview or job outcomes.`
  },
  terms: {
    title: "Terms of Service",
    content: `By using Resume Surgeon services, you agree to:

1. Provide accurate information about your work history and qualifications
2. Respond to intake questions and provide required files in a timely manner
3. Understand that we do not guarantee employment outcomes
4. Use delivered materials for personal job search purposes only
5. Not resell or distribute our work

We reserve the right to decline service for any reason.

Contact us at support@resumesurgeon.net with any questions.`
  }
};
